import Vue from 'vue';
import axios from 'axios';
import store from 'Plugins/vuex';
import VueAxios from 'vue-axios';

Vue.use(VueAxios, axios);

// stage:
// let baseUrl = 'https://dmdint.mcd.arvato-loyalty.io/jcdigitalDev/',
// prod:
let baseUrl = 'https://dmdprod.mcd.arvato-loyalty.io/jcdigital',
  authCode = '61wZf5uvTF8tAkr3VUqNWmjKGpEnClHa',
  registration = '/registration/beginRegistration',
  digitalRegistration = '/registration/queryDefaultDigitalRegistration',
  validateDigitalRegistration = '/registration/validateDigitalRegistration',
  completeRegistration = '/registration/completeRegistration',
  loginParent = '/login/loginParent',
  forgotPassword = '/login/forgotPassword',
  newPassword = '/login/newPassword',
  changeAddress = '/manage/changeParentAddress',
  removeChild = '/manage/removeChild',
  addChild = '/manage/addChild',
  changeOptins = '/manage/changeParentOptins',
  authBasic = 'cmF5U29ubzp7KjYodlY1fjRaPFdidT1pWE1hVQ==',
  headers = {
    'Content-Type': 'application/json',
    Authorization: 'Basic ' + authBasic,
    api_key: authCode,
    Accept: 'application/json',
    session_token: store.state.profileData.sessionToken
  };

export const apiCompleteRegistration = params => {
  headers.session_token = store.state.profileData.sessionToken;

  let config = {
    url: baseUrl + completeRegistration,
    method: 'POST',
    data: { ...params },
    headers
  };

  return axios(config);
};

export const apiDigitalRegistration = params => {
  headers.session_token = store.state.profileData.sessionToken;
  let config = {
    url: baseUrl + digitalRegistration,
    method: 'POST',
    data: { ...params },
    headers
  };

  return axios(config);
};

export const apiValidateDigitalRegistration= params => {
  headers.session_token = store.state.profileData.sessionToken;
  let config = {
    url: baseUrl + validateDigitalRegistration,
    method: 'POST',
    data: { ...params },
    headers
  };

  // return axios(config);
  return axios(config);

  // return axios.post("https://reqres.in/api/articles", article)
  //     .then(response => this.articleId = response.data.id);;
};

export const apiRegistration = params => {
  headers.session_token = store.state.profileData.sessionToken;
  let config = {
    url: baseUrl + registration,
    method: 'POST',
    data: { ...params },
    headers
  };

  return axios(config);
};

export const apiLoginParent = params => {
  headers.session_token = store.state.profileData.sessionToken;
  let config = {
    url: baseUrl + loginParent,
    method: 'POST',
    data: { ...params },
    headers
  };

  return axios(config);
};

export const apiRemoveChild = params => {
  headers.session_token = store.state.profileData.sessionToken;
  let config = {
    url: baseUrl + removeChild,
    method: 'POST',
    data: { ...params },
    headers
  };

  return axios(config);
};

export const apiAddChild = params => {
  headers.session_token = store.state.profileData.sessionToken;
  let config = {
    url: baseUrl + addChild,
    method: 'POST',
    data: { ...params },
    headers
  };
  return axios(config);
};

export const apiChangeAddress = params => {
  headers.session_token = store.state.profileData.sessionToken;
  let config = {
    url: baseUrl + changeAddress,
    method: 'POST',
    data: { ...params },
    headers
  };
  return axios(config);
};

export const apiChangeOptins = params => {
  headers.session_token = store.state.profileData.sessionToken;
  let config = {
    url: baseUrl + changeOptins,
    method: 'POST',
    data: { ...params },
    headers
  };
  return axios(config);
};

export const apiForgotPassword = params => {
  headers.session_token = store.state.profileData.sessionToken;
  let config = {
    url: baseUrl + forgotPassword,
    method: 'POST',
    data: { ...params },
    headers
  };
  return axios(config);
};

export const apiNewPassword = params => {
  headers.session_token = store.state.profileData.sessionToken;
  let config = {
    url: baseUrl + newPassword,
    method: 'POST',
    data: { ...params },
    headers
  };
  return axios(config);
};

// ... to be continued

//
// addAuth: function(params){
//
//     params.api_key = authCode;
// }
